import { Box, Switch, Tooltip, Typography } from '@mui/material';

import AdminIcon from '../../../../../components/CustomIcons/AdminIcon';
import DashboardIcon from '../../../../../components/CustomIcons/DashboardIcon';
import Feature from '../../../../../types/feature';
import { FeatureType } from '../../../../../utils/constants';
import MessageIcon2 from '../../../../../components/CustomIcons/MessageIcon2';
import PagerIcon from '../../../../../components/CustomIcons/PagerIcon';
import React from 'react';
import SettingsIcon from '../../../../../components/CustomIcons/SettingsIcon';
import useStyles from './styles';

interface Props {
  feature: Feature;
  onChange: (isChecked: boolean) => void;
}

/**
 * Renders a card representing a feature with an icon, label, and switch.
 *
 * @param {Props} props - Component props containing the `feature` object.
 * 
 * @returns {JSX.Element} JSX element representing the FeatureCard component.
 */
const FeatureCard: React.FC<Props> = (props: Props) => {

  const styles = useStyles(props.feature);

  /**
   * Retrieves the appropriate icon based on the feature label.
   *
   * @param {string} label - The feature label.
   * 
   * @returns {JSX.Element} The corresponding icon.
   */
  const getIcon = (label: string) => {
    switch (label) {
      case FeatureType.Admin:
        return <AdminIcon />;
      case FeatureType.System:
        return <SettingsIcon />;
      case FeatureType.Messaging:
        return <MessageIcon2 />
      case FeatureType.Pager:
        return <PagerIcon />
      case FeatureType.DashboardAndTeam:
        return <DashboardIcon />
      default:
        return <MessageIcon2 />;
    }
  }

  return (
    <Box sx={styles.itemWrapper}>
      {getIcon(props.feature.label)}
      <Tooltip title={props.feature.label} arrow>
      <Typography variant='subheading' sx={styles.label}>{props.feature.label}</Typography>
      </Tooltip>
      <Switch
        disableRipple
        sx={styles.iosSwitch}
        checked={props.feature.value}
        disabled={props.feature.disabled}
        onChange={(e, checked) => props.onChange(checked)}
      />
    </Box>
  );
};

export default FeatureCard;